 const contacts = {
  state: {
    heatMap: {
      regions: null,
      regionsLoaded: false,
      states: [],
      statesLoaded: false,
      zipcodes: [],
      zipsLoaded: false,
      slackChannels: []
    },
  },
  mutations: {
    setRegions(state, data) {
      state.heatMap.regions = data;
      state.heatMap.regionsLoaded = true;
    },
    setStates(state, data) {
      state.heatMap.states = data;
      state.heatMap.statesLoaded = true;
    },
    setZipCodes(state, data) {
      state.heatMap.zipcodes = data;
      state.heatMap.zipsLoaded = true;
    },
    setSlackChannels(state, data) {
      state.heatMap.slackChannels = data;
    }
  },
  getters: {
    regions: state => {
      return state.heatMap.regions;
    },
    states: state => {
        return state.heatMap.states;
    },
    zipcodes: state => {
        return state.heatMap.zipcodes;
    },
    slackChannels: state => {
        return state.heatMap.slackChannels;
    },
    isRegionsLoaded: state => {
      return state.heatMap.regionsLoaded;
    },
    isStatesLoaded: state => {
      return state.heatMap.statesLoaded;
    },
    isZipsLoaded: state => {
      return state.heatMap.zipsLoaded;
    },
  },
};

 export default contacts;
